/**
 * Returns the default error message as told by Jennifer Landsberg
 */
export default function getErrorMessage(
	monthError: boolean,
	dayError: boolean,
	yearError: boolean,
) {
	return monthError || dayError || yearError
		? 'Please provide a valid Date of Birth'
		: '';
}
